import { Fragment } from "react";
import {
  Box,
  Flex,
  IconButton,
  SimpleGrid,
  GridItem,
  Input,
  InputGroup,
  InputLeftAddon,
  Stack,
} from "@chakra-ui/react";
import { useCustomerQuery } from "../../generated/graphql";
import { FcRefresh, FcEditImage } from "react-icons/fc";
import dayjs from "dayjs";
import Loading from "../../components/loading/Loading";
import Error from "../../components/error/Error";
import PageLayout from "../../components/ui/PageLayout";
import { Link } from "react-router-dom";

interface Props {
  id: string;
}

const Detail: React.VFC<Props> = ({ id }) => {
  const { loading, error, data, refetch } = useCustomerQuery({
    variables: {
      where: {
        id,
      },
    },
    fetchPolicy: "network-only",
  });
  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Error error={error} />;
  }

  return (
    <Fragment>
      <PageLayout>
        <Flex
          mb={6}
          justifyContent={"space-between"}
          alignItems="center"
          bgColor={"gray.100"}
          padding={2}
          rounded="md"
        >
          <Box fontSize={"18px"} fontWeight="bold">
            Müşteri Detayları
          </Box>
          <Flex experimental_spaceX={4}>
            <IconButton
              icon={<FcRefresh />}
              aria-label="Refetch Query"
              onClick={() => refetch()}
            />
            <IconButton
              to={`/customer/update/${id}`}
              as={Link}
              icon={<FcEditImage />}
              aria-label="Add Item"
              onClick={() => refetch()}
            />
          </Flex>
        </Flex>
        <SimpleGrid columns={2} gap={6}>
          <GridItem
            colSpan={{
              base: 3,
              md: 1,
            }}
          >
            <InputGroup>
              <InputLeftAddon width={"120px"} fontSize="xs" children="Kayıt Tarihi" />
              <Input
                fontSize={"sm"}
                disabled
                value={`${dayjs(data?.customer!.createdAt).format("DD MMM YYYY HH:mm")}`}
              />
            </InputGroup>
          </GridItem>

          <GridItem
            colSpan={{
              base: 3,
              md: 1,
            }}
          >
            <InputGroup>
              <InputLeftAddon width={"120px"} fontSize="xs" children="İsim" />
              <Input
                fontSize={"sm"}
                disabled
                value={`${data?.customer!.name} ${data?.customer!.surname}`}
              />
            </InputGroup>
          </GridItem>

          <GridItem
            colSpan={{
              base: 3,
              md: 1,
            }}
          >
            <InputGroup>
              <InputLeftAddon width={"120px"} fontSize="xs" children="E-Posta" />
              <Input fontSize={"sm"} disabled value={`${data?.customer!.email}`} />
            </InputGroup>
          </GridItem>

          <GridItem
            colSpan={{
              base: 3,
              md: 1,
            }}
          >
            <InputGroup>
              <InputLeftAddon width={"120px"} fontSize="xs" children="Telefon" />
              <Input fontSize={"sm"} disabled value={`${data?.customer!.phoneNumber}`} />
            </InputGroup>
          </GridItem>

          <GridItem
            colSpan={{
              base: 3,
              md: 1,
            }}
          >
            <InputGroup>
              <InputLeftAddon width={"120px"} fontSize="xs" children="Telefon Onayı" />
              <Input
                fontSize={"sm"}
                disabled
                value={`${data?.customer!.phoneActivated ? "Onaylı" : "Onaysız"}`}
              />
            </InputGroup>
          </GridItem>

          <GridItem
            colSpan={{
              base: 3,
              md: 1,
            }}
          >
            <InputGroup>
              <InputLeftAddon width={"120px"} fontSize="xs" children="E-Posta Onayı" />
              <Input
                fontSize={"sm"}
                disabled
                value={`${data?.customer!.emailActivated ? "Onaylı" : "Onaysız"}`}
              />
            </InputGroup>
          </GridItem>
        </SimpleGrid>
      </PageLayout>

      <PageLayout>
        <Flex
          mb={6}
          justifyContent={"space-between"}
          alignItems="center"
          bgColor={"gray.100"}
          padding={2}
          rounded="md"
        >
          <Box fontSize={"18px"} fontWeight="bold">
            Adresler
          </Box>
        </Flex>

        {data!.customer!.addresses.map((address) => {
          return (
            <Stack direction="column" px={3} py={2} border="1px solid #ccc">
              <Box fontWeight="semibold">Başlık: {address.title}</Box>
              <Box>Adres 1: {address.addressLineOne}</Box>
              <Box>Adres 2: {address.addressLineTwo}</Box>
              <Box>Posta Kodu: {address.postalCode}</Box>
              <Box>Şehir: {address.city}</Box>
              <Box>İlçe: {address.state}</Box>
            </Stack>
          );
        })}
      </PageLayout>
    </Fragment>
  );
};

export default Detail;
